import script from "./STDSDC01C11TaxOfficeListModal.vue?vue&type=script&setup=true&lang=js"
export * from "./STDSDC01C11TaxOfficeListModal.vue?vue&type=script&setup=true&lang=js"

import "./STDSDC01C11TaxOfficeListModal.vue?vue&type=style&index=0&id=1d66ad71&scoped=true&lang=css"

import exportComponent from "D:\\TDS\\40_製造(M)\\99_電帳法_USE\\Tatsuzin_filemanage\\vue\\tdsvue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d66ad71"]])

export default __exports__